import React, { useEffect, useRef, useState } from 'react';

import { Stack } from 'react-bootstrap';

import { LomavisHeatMap1 } from '@/lomavisSharedUi/atoms/charts/LomavisHeatMap1';

interface ILomavisMultipleHeatmap1Props {
  competitorsData: Array<{
    name: string;
    data: Array<{ title: string; data: Record<number, number> }>;
  }>;
  metric?: string;
}

/**
 * Molecules: ILomavisMultipleHeatmap1
 */
export const ILomavisMultipleHeatmap1: React.FC<
  ILomavisMultipleHeatmap1Props
> = ({ competitorsData, metric }) => {
  const [selectedName, setSelectedName] = useState(
    competitorsData[0]?.name || ''
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const selected = competitorsData.find((c) => c.name === selectedName);

  useEffect(() => {
    setSelectedName(competitorsData[0]?.name);
  }, [competitorsData]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (
        showDropdown &&
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target as Node)
      ) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [showDropdown]);

  return (
    <Stack>
      <div className="w-100 d-flex justify-content-end">
        {competitorsData.length > 1 && (
          <div className="dropdown mb-3" ref={dropdownRef}>
            <button
              className="btn btn-secondary btn-sm dropdown-toggle text-capitalize"
              type="button"
              aria-expanded={showDropdown}
              onClick={() => setShowDropdown((prev) => !prev)}
            >
              {selectedName}
            </button>
            <ul className={`dropdown-menu${showDropdown ? ' show' : ''}`}>
              {competitorsData.map((c) => (
                <li key={c.name} className="w-100 p-1">
                  <button
                    className={`dropdown-item text-capitalize${
                      c.name === selectedName ? ' active' : ''
                    }`}
                    type="button"
                    onClick={() => {
                      setSelectedName(c.name);
                      setShowDropdown(false);
                    }}
                  >
                    {c.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {selected && <LomavisHeatMap1 data={selected.data} metric={metric} />}
    </Stack>
  );
};
